import React from 'react';

import { Box, Text } from '@chakra-ui/react';

interface Props {
  label: string;
  onClick?: () => void;
}

export const DottedUnderlineLink = (props: Props) => {
  const { label, onClick } = props;
  return (
    <Box onClick={onClick} _hover={{ cursor: 'pointer' }} color="primary">
      <Text
        textDecoration="underline"
        textDecorationStyle="dotted"
        textUnderlineOffset="3px"
      >
        {label}
      </Text>
    </Box>
  );
};
